import Vue from 'vue'
import Router from 'vue-router'
import store from './store.js'
import SiteDown from './views/public/SiteDown.vue'

Vue.use(Router)

let router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: () => import('./pages/Index.vue'),
    },
    {
      path: '/archived',
      name: 'archived',
      component: () => import('./pages/user/Archived.vue'),
    },
    {
      path: '/sitedown',
      name: 'sitedown',
      component: SiteDown,
    },
    {
      path: '/agent',
      name: 'agent',
      component: () => import('./views/public/Agent.vue'),
    },
    {
      path: '/password/forgot',
      name: 'forgotpassword',
      component: () => import('./views/public/Password/Forgot.vue'),
    },
    {
      path: '/password/new',
      name: 'newpassword',
      component: () => import('./views/public/Password/New.vue'),
    },
    {
      path: '/portal/:clientname',
      name: 'portal',
      component: () => import('./views/public/ClientLandingPage.vue'),
    },
    {
      path: '/portal/:clientname/:eventId(\\d+)',
      name: 'portalevent',
      component: () => import('./views/public/ClientRegistrationPage.vue'),
    },
    {
      path: '/portal/:clientName/:landingPage',
      name: 'customLandingPage',
      component: () => import('./views/public/ClientLandingMultiPage.vue'),
    },
    {
      path: '/portal/:clientname/drip/:dripCode',
      name: 'portaldrip',
      component: () => import('./views/public/ClientDripEnrollmentPage.vue'),
    },
    {
      path: '/event/:eventId',
      name: 'event',
      meta: { requiresAuth: true },
      component: () => import('./pages/event/EventPage.vue'),
    },
    {
      path: '/event/:eventId/activity/:activityId',
      name: 'activities',
      meta: { requiresAuth: true },
      component: () => import('./pages/event/EventPage.vue'),
    },
    {
      path: '/drip/:dripCode',
      name: 'dripPage',
      meta: { requiresAuth: true },
      component: () => import('./pages/drip/DripPage.vue'),
    },
    {
      path: '/drip/:dripCode/activity/:activityId',
      name: 'dripPageActivity',
      meta: { requiresAuth: true },
      component: () => import('./pages/drip/DripPage.vue'),
    },
    {
      path: '/authorize/telegram',
      name: 'telegram',
      meta: { requiresAuth: true },
      component: () => import('./pages/authorize/Telegram.vue'),
    },
    {
      path: '/account/profile',
      name: 'profile',
      meta: { requiresAuth: true },
      component: () => import('./pages/account/Profile.vue'),
    },
    {
      path: '/account/subscription',
      name: 'subscription',
      meta: { requiresAuth: true },
      component: () => import('./pages/account/Subscription.vue'),
    },
    {
      path: '/account/webhooks',
      name: 'webhooks',
      meta: { requiresAuth: true },
      component: () => import('./pages/account/webhooks/Index.vue'),
    },
    {
      path: '/account/webhooks/add/',
      name: 'addWebhook',
      meta: { requiresAuth: true },
      component: () => import('./pages/account/webhooks/Edit.vue'),
    },
    {
      path: '/account/webhooks/edit/:id',
      name: 'editWebhook',
      meta: { requiresAuth: true },
      component: () => import('./pages/account/webhooks/Edit.vue'),
    },
    {
      path: '/account/landingpages',
      name: 'editLandingPages',
      meta: { requiresAuth: true },
      component: () => import('./pages/account/LandingPages.vue'),
    },
    {
      path: '/account/dashboard',
      name: 'dashboard',
      meta: { requiresAuth: true },
      component: () => import('./pages/account/Dashboard.vue'),
    },
    {
      path: '/account/drip',
      name: 'drips',
      meta: { requiresAuth: true },
      component: () => import('./pages/account/Drips.vue'),
    },
    {
      path: '/account/event/:eventid/edit',
      name: 'editEvent',
      meta: { requiresAuth: true },
      component: () => import('./pages/account/event/_eventid/Edit.vue'),
    },
    {
      path: '/account/event/:eventid/users',
      name: 'registeredUsers',
      meta: { requiresAuth: true },
      component: () => import('./pages/account/event/_eventid/Users.vue'),
    },
    {
      path: '/account/event/:eventid/user/:userid',
      name: 'eventUserDetail',
      meta: { requiresAuth: true },
      component: () => import('./pages/account/event/_eventid/UserDetail.vue'),
    },
    {
      path: '/account/drip/:dripcode/edit',
      name: 'editDrip',
      meta: { requiresAuth: true },
      component: () => import('./pages/account/drip/_dripcode/Edit.vue'),
    },
    {
      path: '/account/drip/:dripcode/users',
      name: 'registeredDripUsers',
      meta: { requiresAuth: true },
      component: () => import('./pages/account/drip/_dripcode/Users.vue'),
    },
    {
      path: '/account/drip/:dripcode/messages',
      name: 'chatDripUsers',
      meta: { requiresAuth: true },
      component: () => import('./pages/account/drip/_dripcode/Messages.vue'),
    },
    {
      path: '/account/drip/:dripcode/user/:userid',
      name: 'dripUserDetail',
      meta: { requiresAuth: true },
      component: () => import('./pages/account/drip/_dripcode/UserDetail.vue'),
    },
    {
      path: '/account/event/sales',
      name: 'eventSalesHistory',
      meta: { requiresAuth: true },
      component: () => import('./pages/account/event/SalesHistory.vue'),
    },
    {
      path: '/account/event/:eventid/live/selection',
      name: 'liveSelection',
      meta: { requiresAuth: true },
      component: () =>
        import('./pages/account/event/_eventid/live/Selection.vue'),
    },
    {
      path: '/account/event/:eventid/live/:activitydayid/content/',
      name: 'liveContentEdit',
      meta: { requiresAuth: true },
      component: () =>
        import('./pages/account/event/_eventid/live/Content.vue'),
    },
    {
      path: '/account/event/:eventid/live/:activitydayid/content/:activityId',
      name: 'liveContent',
      meta: { requiresAuth: true },
      component: () =>
        import('./pages/account/event/_eventid/live/Content.vue'),
    },
    {
      path: '/account/template/:moduleId',
      name: 'templateedit',
      meta: { requiresAuth: true },
      component: () => import('./views/account/TemplateEdit.vue'),
      children: [
        {
          path: 'activity/:id',
          component: () => import('./views/account/TemplateActivity.vue'),
        },
        {
          // Used when the "Add Day" button is clicked
          path: 'activity/:id/:day',
          component: () => import('./views/account/TemplateActivity.vue'),
        },
        {
          path: 'day/:id',
          component: () => import('./views/account/TemplateDay.vue'),
        },
      ],
    },
    // account/templates  ///////////////////////////////////////////
    {
      path: '/account/templates',
      name: 'templates',
      meta: { requiresAuth: true },
      component: () => import('./pages/account/templates/Index.vue'),
    },
    {
      path: '/account/templates/sales',
      name: 'templateSalesHistory',
      meta: { requiresAuth: true },
      component: () => import('./pages/account/templates/SalesHistory.vue'),
    },
    {
      path: '/account/templates/:id/edit',
      name: 'TemplateEdit',
      meta: { requiresAuth: true },
      component: () => import('./pages/account/templates/Edit.vue'),
    },
    {
      path: '/account/templates/:id/event/email',
      name: 'templateEventEmail',
      meta: { requiresAuth: true },
      component: () => import('./pages/account/templates/EventEmail.vue'),
    },
    {
      path: '/account/templates/:id/drip/email',
      name: 'templateDripEmail',
      meta: { requiresAuth: true },
      component: () => import('./pages/account/templates/DripEmail.vue'),
    },
    {
      path: '/account/templates/:id/salesdetail',
      name: 'templatesalesdetail',
      meta: { requiresAuth: true },
      component: () => import('./pages/account/templates/SalesDetail.vue'),
    },
    // //////////////////////////////////////////////////////////////
    {
      path: '/account/settings',
      name: 'settings',
      meta: { requiresAuth: true },
      component: () => import('./pages/account/Settings.vue'),
    },
    {
      path: '/account/contributor',
      name: 'contributor',
      meta: { requiresAuth: true },
      component: () => import('./pages/account/Contributor.vue'),
    },
    {
      path: '/seller/checkout',
      name: 'sellercheckout',
      meta: { requiresAuth: true },
      component: () => import('./pages/seller/Checkout.vue'),
    },
    {
      path: '/purchase',
      name: 'purchase',
      redirect: '/purchase/templates',
      meta: { requiresAuth: true },
      component: {
        render(c) {
          return c('router-view')
        },
      },
      children: [
        {
          path: 'templates',
          name: 'Templates For Sale',
          component: () => import('./pages/purchase/templates/Index.vue'),
        },
        {
          path: 'templates/history',
          name: 'Purchase History',
          component: () => import('./pages/purchase/templates/History.vue'),
        },
        {
          path: 'templates/:id',
          name: 'Template Detail',
          component: () => import('./pages/purchase/templates/Detail.vue'),
        },
      ],
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('./views/public/Login.vue'),
    },
    {
      path: '/register',
      name: 'register',
      component: () => import('./pages/register/Index.vue'),
    },
    {
      path: '/register/success/paypal',
      name: 'success2',
      component: () => import('./pages/register/Success.vue'),
    },
    {
      path: '/register/success',
      name: 'success',
      component: () => import('./pages/register/Success.vue'),
    },
    {
      path: '/pricing',
      name: 'pricing',
      component: () => import('./pages/Index.vue'),
    },
    {
      path: '/about',
      name: 'about',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import('./pages/about/Index.vue'),
    },
    {
      path: '/about/terms',
      name: 'terms',
      component: () => import('./pages/about/Terms.vue'),
    },
    {
      path: '/about/privacy',
      name: 'privacy',
      component: () => import('./pages/about/Privacy.vue'),
    },
    {
      path: '/about/saprivacy',
      name: 'saprivacy',
      component: () => import('./pages/about/saPrivacy.vue'),
    },
    {
      path: '/about/eula',
      name: 'eula',
      component: () => import('./pages/about/eula.vue'),
    },
    {
      path: '/about/removeme',
      name: 'removeuser',
      component: () => import('./pages/about/removeMe.vue'),
    },
    { path: '*', redirect: '/' },
  ],
})

// https://jasonwatmore.com/post/2018/07/14/vue-vuex-user-registration-and-login-tutorial-example
// https://pusher.com/tutorials/authentication-vue-vuex
router.beforeEach((to, from, next) => {
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (store.getters.isLoggedIn) {
      next()
      return
    }
    // next('/login')
    next({ name: 'login', query: { redirect: to.fullPath } })
  } else {
    next()
  }
})

export default router
